<template>
  <div class="Construction7">
    <!-- 劳务公司页面 -->
    <div class="screen_content">
      <div class="tableTitle">
        <div
          class="right"
          :class="checkIndex == 0 ? 'OnAction' : 'unAction'"
          @click="check(0)"
          style="margin-left: 10px"
        >
          <span>施工队</span>
        </div>
        <div class="light"></div>
        <div
          class="right"
          :class="checkIndex == 1 ? 'OnAction' : 'unAction'"
          @click="check(1)"
        >
          <span>班组工队</span>
        </div>
        <div class="light"></div>

        <div
          class="right"
          :class="checkIndex == 3 ? 'OnAction' : 'unAction'"
          @click="check(3)"
        >
          <span>工程公司</span>
        </div>
        <div class="light"></div>
        <div
          class="right"
          :class="checkIndex == 5 ? 'OnAction' : 'unAction'"
          @click="check(5)"
        >
          <span>劳务公司</span>
        </div>
      </div>
      <LaborServiceCompany
        v-if="checkIndex === 5"
        :top="false"
      ></LaborServiceCompany>
    </div>
  </div>
</template>

<script>
import sessionStorage from "@/storage/sessionStorage"
export default {
  name: "LaborTeamList",
  components: {
    //劳务公司
    LaborServiceCompany: () =>
      import("@/views/LaborServiceCompany/LaborServiceCompany.vue")
  },
  data() {
    return {
      checkIndex: 5,
    }
  },
  mounted() {},
  // 方法
  methods: {
    // 选项卡切换
    check(index) {
      if (index == 0) {
        this.$router.push({
          path: "/teamList",
          query: { name: "施工队" }
        })
      } else if (index == 1) {
        this.$router.push({
          path: "/teamList",
          query: { name: "班组工队" }
        })
      } else if (index == 3) {
        this.$router.push({
          path: "/teamList",
          query: { name: "工程公司" }
        })
      }
    }
  },
  destroyed() {
    sessionStorage.clear("query")
    sessionStorage.clear("routerKey")
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.Construction7 {
  .demo-form-inline {
    width: 1200px;
    margin: 3px auto 0;
    height: 41px;
  }
  .tableTitle {
    width: 1198px;
    height: 40px;
    margin: 10px auto 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: white;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    .left {
      margin-left: 10px;
      padding: 16px 15px;
    }

    .light {
      margin: 0 10px;
      width: 1px;
      height: 24px;
      background: rgba(228, 231, 237, 1);
    }

    .right {
      padding: 0px 15px;
      height: 58px;
      line-height: 58px;
    }

    .OnAction {
      span {
        color: #e1251b;
        border-bottom: 2px solid #e1251b;
        font-weight: bold;
        display: inline-block;
        height: 47px;
      }
    }
    .unAction {
      border-bottom: none;
    }
  }
  .tab-box {
    width: 1200px;
    margin: 0 auto;

    .inner {
      background: #f5f5f5;

      > div {
        background: white;
        display: inline-block;
        width: 105px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        border: 1px solid rgba(228, 231, 237, 1);
      }

      .check {
        // background: #fff;
        color: #e1251b;
        position: relative;
        font-weight: bold;
        // &::before {
        //   content: "";
        //   display: block;
        //   position: absolute;
        //   top: -1px;
        //   left: 0;
        //   width: 100%;
        //   border-top: 2px solid #eee;
        // }
        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          border-top: 1px solid #fff;
        }
      }
    }
  }
}
.nodata-box {
  width: 1200px;
  margin: 0 auto 10px;
}
.tc-5 {
  height: 5px;
}
</style>
<style lang="scss" rel="stylesheet/scss">
.Construction7 {
  .el-pager li {
    background: none;
  }
  .el-pagination button:disabled {
    background: none;
  }
  .btn-next {
    background: none;
  }
  .btn-prev {
    background: none;
  }
  .screen_content {
    // padding-top: 10px;
    &_box {
      background-color: #fff;
      border-left: 1px solid #e4e7ed;
      border-right: 1px solid #e4e7ed;
      margin: 0 auto;
      width: 1198px;
    }
  }
  .listTitle {
    width: 1200px;
    margin: 0 auto;
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    padding: 8px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    .cuper {
      cursor: pointer;
    }
    .line {
      width: 1px;
      height: 24px;
      background: #e4e7ed;
      margin: 0 20px;
    }
    img {
      width: 16px;
      height: 16px;
      margin-right: 9px;
    }
  }
  .table {
    position: relative;
    width: 1200px;
    overflow: hidden;
    min-height: 400px;
    margin: 10px auto 0;
    border: 1px solid #e4e7ed;
    .left {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
    }
    .right {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 20px;
      top: 5px;

      img {
        display: inline-block;
        // width: 14px;
        // height: 14px;
        // margin-right: 5px;
      }
      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(2, 134, 223, 1);
      }
    }
    /deep/ .el-tabs__item {
      font-size: 16px;
    }
  }
  .tableTitle {
    width: 1198px;
    height: 40px;
    // margin: 5px auto 10px;
    margin: 5px auto 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: white;
    // border-bottom: 1px solid rgba(228, 231, 237, 1);
    cursor: pointer;

    .left {
      margin-left: 10px;
      padding: 16px 15px;
    }

    .light {
      margin: 0 10px;
      width: 1px;
      height: 24px;
      background: rgba(228, 231, 237, 1);
    }

    .right {
      padding: 0px 15px;
    }

    // .OnAction {
    //   color: #0286df;
    //   border-bottom: 2px solid #0286df;
    // }

    .unAction {
      border-bottom: 2px solid white;
    }
  }
}
</style>
>>>>>>>>> Temporary merge branch 2
